
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.25 16.39a2.59 2.59 0 00-2.91-.51l-1.79-1.79a2 2 0 000-.24 4.22 4.22 0 00-1.22-3.47l-.2-.2a6.43 6.43 0 01-1.69-3.47A6.72 6.72 0 103.1 12.63a6.65 6.65 0 003.56 1.86 6.76 6.76 0 013.62 1.82 4.47 4.47 0 003.15 1.31 3.56 3.56 0 00.8-.08l1.7 1.69a2.57 2.57 0 104.83 1.53A2.58 2.58 0 0023 18.21a2.58 2.58 0 00-.75-1.82zm-10.56-1.5A8.78 8.78 0 007 12.52a4.71 4.71 0 01-3.84-5.13 4.81 4.81 0 012.17-3.52 4.68 4.68 0 015 0 4.74 4.74 0 012.16 3.21 8.34 8.34 0 002.25 4.53l.2.2a2.26 2.26 0 01.64 1.85 2.2 2.2 0 01-1 1.65 2.33 2.33 0 01-2.89-.42zm9.14 3.72a.51.51 0 01-.47.16 1.43 1.43 0 00-1.59 1.59.51.51 0 01-.16.47.57.57 0 01-.88-.71 1.67 1.67 0 00-.08-2l-1.51-1.52a3.19 3.19 0 00.54-.56l1.47 1.47a1.69 1.69 0 002 .21.57.57 0 01.71.88z"}}),_c('circle',{attrs:{"cx":"8.97","cy":"6.36","r":".71"}}),_c('circle',{attrs:{"cx":"11.95","cy":"10.55","r":".71"}}),_c('circle',{attrs:{"cx":"9.41","cy":"9.14","r":".71"}}),_c('circle',{attrs:{"cx":"6.18","cy":"6.03","r":".71"}})])
          )
        }
      }
    